import CurrencyList from 'currency-list';

// Currencies our exchange rates (fixer.io) know but the currency-list package doesn't: rate files
// price local charges in them (Samoa, Vanuatu, Fiji…), and without them a price showed as blank.
// Added to the package's own list once, so every picker, label and price sees them.
// code: [name, symbol, decimal digits]
const EXTRA_CURRENCIES = {
    ANG: ['Netherlands Antillean Guilder', 'NAf.', 2],
    AOA: ['Angolan Kwanza', 'AOA', 2],
    AWG: ['Aruban Florin', 'Afl.', 2],
    BBD: ['Barbadian Dollar', 'Bds$', 2],
    BMD: ['Bermudan Dollar', 'BD$', 2],
    BSD: ['Bahamian Dollar', 'B$', 2],
    BTN: ['Bhutanese Ngultrum', 'BTN', 2],
    CUP: ['Cuban Peso', 'CUP', 2],
    FJD: ['Fijian Dollar', 'FJ$', 2],
    FKP: ['Falkland Islands Pound', 'FKP', 2],
    GIP: ['Gibraltar Pound', 'GIP', 2],
    GMD: ['Gambian Dalasi', 'GMD', 2],
    GYD: ['Guyanaese Dollar', 'G$', 2],
    HTG: ['Haitian Gourde', 'HTG', 2],
    KGS: ['Kyrgyz Som', 'KGS', 2],
    KPW: ['North Korean Won', 'KPW', 0],
    KYD: ['Cayman Islands Dollar', 'CI$', 2],
    LAK: ['Laotian Kip', '₭', 0],
    LRD: ['Liberian Dollar', 'L$', 2],
    LSL: ['Lesotho Loti', 'LSL', 2],
    MNT: ['Mongolian Tugrik', '₮', 2],
    MRU: ['Mauritanian Ouguiya', 'MRU', 2],
    MVR: ['Maldivian Rufiyaa', 'Rf', 2],
    MWK: ['Malawian Kwacha', 'MK', 2],
    PGK: ['Papua New Guinean Kina', 'K', 2],
    SBD: ['Solomon Islands Dollar', 'SI$', 2],
    SCR: ['Seychellois Rupee', 'SCR', 2],
    SHP: ['St. Helena Pound', 'SHP', 2],
    SLE: ['Sierra Leonean Leone', 'SLE', 2],
    SRD: ['Surinamese Dollar', 'Sr$', 2],
    SSP: ['South Sudanese Pound', 'SSP', 2],
    STN: ['São Tomé & Príncipe Dobra', 'STN', 2],
    SVC: ['Salvadoran Colón', 'SVC', 2],
    SZL: ['Swazi Lilangeni', 'SZL', 2],
    TJS: ['Tajikistani Somoni', 'TJS', 2],
    TMT: ['Turkmenistani Manat', 'TMT', 2],
    VES: ['Venezuelan Bolívar', 'VES', 2],
    VUV: ['Vanuatu Vatu', 'VT', 0],
    WST: ['Samoan Tala', 'WS$', 2],
    XCD: ['East Caribbean Dollar', 'EC$', 2],
    XPF: ['CFP Franc', 'CFP', 0],
    ZMW: ['Zambian Kwacha', 'ZK', 2],
};

// The app reads the list as getAll('en_US'), getAll()['en'] and get(code), which is en_US.
['en_US', 'en'].forEach(locale => {
    const list = CurrencyList.getAll(locale);
    if (!list) return;
    Object.entries(EXTRA_CURRENCIES).forEach(([code, [name, symbol, digits]]) => {
        if (list[code]) return;
        list[code] = { name, symbol_native: symbol, symbol, code, name_plural: name, rounding: 0, decimal_digits: digits };
    });
});

export default EXTRA_CURRENCIES;
